<template lang="html">
  <div class="admin-vacancies-scene">
    {{ filterCompany }}
    <status-list v-if="!loading" :list="statuses" @sort_change="fetch" />

    <vpreloader v-else />
  </div>
</template>

<script>
import { STORE_PREFIX } from '../constants.js';
import { mapGetters } from 'vuex';

import StatusList from './List.vue';

export default {
  name: 'AdminResponseStatusesScene',

  components: {
    StatusList
  },

  props: {
    filterCompany: Object,
    companyId: null
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      loading: 'response-statuses/loading',
      statuses: 'response-statuses/list',
      pagination: 'response-statuses/pagination'
    })
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$store.dispatch(STORE_PREFIX + 'admin/response-statuses/fetch', {
        company_id: this.companyId
      });
    },

    onPageChange(pageNumber) {
      this.$store.commit(STORE_PREFIX + 'admin/response-statuses/updatePagination', {
        pageNumber
      });
      this.fetch();
    },

    onLimitChange(count) {
      this.$store.commit(STORE_PREFIX + 'admin/response-statuses/updatePagination', {
        count
      });
      this.fetch();
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination:first-child {
  padding: 0 0 20px 0;
}
</style>
